import React from 'react';
import {
    UploadStatus,
    FieldProgress,
    FieldProgressType,
    defaultFieldProgress,
} from '../NewPack.constants';

export type UploadFieldContextType = {
    getUploadStatus: (fieldKey: string) => UploadStatus;
    setUploadStatus: (fieldKey: string, status: UploadStatus) => void;
    getUploadProgress: (fieldKey: string) => FieldProgress;
    setUploadProgress: (fieldKey: string, progression: FieldProgress) => void;
    doUpload: (fieldKey: string, file: File) => void;
    fieldProgress: FieldProgressType;
};

export const UploadFieldContext = React.createContext<UploadFieldContextType>({
    getUploadStatus: () => 'pending',
    setUploadStatus: () => undefined,
    getUploadProgress: () => {
        return { uploaded: 0, total: 0 };
    },
    setUploadProgress: () => undefined,
    doUpload: () => undefined,
    fieldProgress: defaultFieldProgress,
});
